import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {facultyUpdateTt} from '../../redux/action/facultyAction'
import FacultyHomeHelper from '../../Components/FacultyHomeHelper';
import { useParams,useHistory,Link } from 'react-router-dom';

const FacultyCreateTimeTable = () => {
  const { timetableId } = useParams();
  const timetable = useSelector((store) => {
    return store.faculty.timetableData.find((timetable) => timetable._id === timetableId);
  });
  const dispatch = useDispatch();
  const [section, setSection] = useState(timetable ? timetable.section : '');
  const [semester, setSemester] = useState(timetable ? timetable.semester : '');
  const [year, setYear] = useState(timetable ? timetable.year : '');
  const [department, setDepartment] = useState(timetable ? timetable.department : '');
  const [timetableData, setTimetableData] = useState(timetable ? timetable.timetable : []);
  const history = useHistory();

  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

  const periods = [
    '1st Period  <small>(9:00 to 9:55)</small>',
    '2nd Period  <small>(9:55 to 10:50)</small>',
    '3rd Period  <small>(11:05 to 11:55)</small>',
    '4th Period  <small>(12:55 to 12:45)</small>',
    '5th Period  <small>(1:15 to 2:10)</small>',
    '6th Period  <small>(2:10 to 3:00)</small>',
    '7th Period  <small>(3:10 to 4:00)</small>',
    'Coaching  <small>(4:10 to 5:30)</small>',
  ];

  const formHandler = (e) => {
    e.preventDefault();
    const confirmation = window.confirm('Are you sure you want to update this TimeTable?');
  
    
    if (!timetableId) {
      console.error("Timetable ID is undefined");
      return;
    }
  
    const timetableData = {
      year,
      section,
      semester,
      timetable: daysOfWeek.map((day, dayIndex) => ({
        day,
        periods: periods.map((period, periodIndex) => {
          const inputFieldName = `${day}-${periodIndex + 1}`;
          const inputValue = e.target[inputFieldName]?.value;
          return {
            periodName: `${periodIndex + 1}st Period`,
            content: inputValue,
          };
        }),
      })),
    };
    if (confirmation) {
      dispatch(facultyUpdateTt(timetableId, timetableData))
        .then(() => {
          alert('TimeTable updated successfully');
          window.location.href = '/FacultyTimeTable'; // Redirect to the desired URL
        })
        .catch((error) => {
          alert('Failed to update TimeTable');
          console.error(error);
        });
    }
  };
  
  const handleInputChange = (e, day, periodIndex) => {
    const newValue = e.target.value;
  
    // Update the timetableData state with the new value
    const updatedTimetableData = timetableData.map((entry) => {
      if (entry.day === day) {
        return {
          ...entry,
          periods: entry.periods.map((period, index) => {
            if (index + 1 === periodIndex) {
              return {
                ...period,
                content: newValue,
              };
            }
            return period;
          }),
        };
      }
      return entry;
    });
  
    setTimetableData(updatedTimetableData);
  };
  

  return (
    <div>

        <>
          <div className="container-fluid p-0">
            <div className="d-flex">
              <div className="print-helper">
                <FacultyHomeHelper />
              </div>
              <div className="mx-1 w-100 ">
                <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                <h5><Link to='/FacultyTimeTable' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>

                  <h3> <img src="/logo192.png" width={'50px'} alt="" /> Time Table</h3>
                  <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                </div>
                <div className="col d-md-flex align-items-center justify-content-between">
                            <form form-inline  noValidate onSubmit={formHandler}>
                      <div className="col m-auto">
                          <div>
                            <div className="resultT p-2">
                              <h2 className="text-center">TimeTable</h2>
                              <div className="d-flex w-100 justify-content-around mt-3">
                                <h5>Department :{department} </h5>
                                <h5>Year : {year} </h5>
                                <h5>Semester : {semester} </h5>
                                <h5>Section : {section} </h5>
                              </div>
                            </div>
                            <table className="table resultT p-2 table-responsive table-striped table-bordered">
                              <thead>
                                <tr className="table resultTcol text-light">
                                  <th width="10%">Day</th>
                                  {periods.map((period, index) => (
                                    <th width="10%" key={index}>
                                      <span dangerouslySetInnerHTML={{ __html: period }} />
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {daysOfWeek.map((day, dayIndex) => (
                                  <tr key={dayIndex}>
                                    <td>{day}</td>
                                    {periods.map((period, periodIndex) => {
                                      const timetableEntry = timetableData.find(
                                        (entry) =>
                                          entry.day === day &&
                                          entry.periods[periodIndex].periodName === `${periodIndex + 1}st Period`
                                      );
                                      return (
                                        <td key={periodIndex}>
                                          <input
                                            className="form-control form-control-sm"
                                            type="text"
                                            value={timetableEntry ? timetableEntry.periods[periodIndex].content : ''}
                                            name={`${day}-${periodIndex + 1}`}
                                            onChange={(e) => handleInputChange(e, day, periodIndex + 1)}
                                          />
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                  </div>
                  <button  type="submit" className=" btn-success btn text-light m-2" > <img src="/image/add.svg" lt="" /> Upload TimeTable</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>

    </div>
  );
};

export default FacultyCreateTimeTable;
